// Simple API client for users. Reads JWT auth token from localStorage under 'authToken'.
import { BASE } from './../../config/setting';

function getAuthHeader() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function handleResponse(res) {
  if (!res.ok) {
    // Try to parse JSON error, fallback to text if HTML/other
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const error = await res.json();
      throw new Error(error.message || JSON.stringify(error));
    } else {
      // Backend not running or returned HTML
      throw new Error(
        `API Error (${res.status}): ${res.statusText}. ` +
        `Make sure backend is running at ${BASE}`
      );
    }
  }
  return res.json();
}

export async function fetchUsers() {
  try {
    const res = await fetch(`${BASE}/api/users`, { 
      headers: { ...getAuthHeader() } 
    });
    return await handleResponse(res);
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error(`Cannot connect to backend at ${BASE}. Make sure it's running.`);
    }
    throw error;
  }
}

export async function createUser(payload) {
  try {
    const res = await fetch(`${BASE}/api/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(payload),
    });
    return await handleResponse(res);
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error(`Cannot connect to backend at ${BASE}. Make sure it's running.`);
    }
    throw error;
  }
}

export async function updateUser(id, payload) {
  try {
    const res = await fetch(`${BASE}/api/users/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(payload),
    });
    return await handleResponse(res);
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error(`Cannot connect to backend at ${BASE}. Make sure it's running.`);
    }
    throw error;
  }
}

export async function deleteUser(id) {
  try {
    const res = await fetch(`${BASE}/api/users/${id}`, {
      method: 'DELETE',
      headers: { ...getAuthHeader() },
    });
    return await handleResponse(res);
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error(`Cannot connect to backend at ${BASE}. Make sure it's running.`);
    }
    throw error;
  }
}
